<div
  (click)="openEstimationDialog()"
  class="flex min-w-0 max-w-full flex-wrap hover-opacity gap-3"
>
  <!-- Time Estimation -->
  @if (showTime()) {
    <div class="flex min-w-0 max-w-full items-center gap-2">
      <mat-icon
        fontIcon="timer"
        class="icon-muted shrink-0"
      />
      <p
        [class.opacity-50]="!timeEstimationPresent()"
        [class.lowercase]="!timeEstimationPresent()"
        [matTooltipDisabled]="!timeEstimationPresent()"
        [matTooltip]="'project-tasks.list.column-headers.estimated-time' | translate"
        class="min-w-0 truncate"
      >
        {{
          ($safeNavigationMigration(estimation()?.time) | intlDuration) ||
            ('project-tasks.list.column-headers.estimated-time' | translate)
        }}
      </p>
    </div>
  }

  <!-- Cost Estimation -->
  @if (showCost()) {
    <div class="flex min-w-0 max-w-full items-center gap-2">
      <mat-icon
        fontIcon="paid"
        class="icon-muted shrink-0"
      />
      <p
        [class.opacity-50]="!costEstimationPresent()"
        [class.lowercase]="!costEstimationPresent()"
        [matTooltipDisabled]="!costEstimationPresent()"
        [matTooltip]="'project-tasks.list.column-headers.estimated-cost' | translate"
        class="min-w-0 truncate"
      >
        {{
          costEstimationPresent()
            ? ($safeNavigationMigration(estimation()?.financial?.amount)
              | intlCurrency: $safeNavigationMigration(estimation()?.financial?.currency?.toUpperCase()))
            : ('project-tasks.list.column-headers.estimated-cost' | translate)
        }}
      </p>
    </div>
  }

  <!-- Quantity Estimation -->
  @if (showQuantity()) {
    <div class="flex min-w-0 max-w-full items-center gap-2">
      <mat-icon
        fontIcon="package_2"
        class="icon-muted shrink-0"
      />
      <p
        [class.opacity-50]="!quantityEstimationPresent()"
        [class.lowercase]="!quantityEstimationPresent()"
        [matTooltipDisabled]="!quantityEstimationPresent()"
        [matTooltip]="estimatedQuantityLabelKey | translate"
        class="min-w-0 truncate"
      >
        @if (quantityEstimationPresent()) {
          {{ quantityEstimationAmount() }} {{ quantityUnitTranslationKey() | translate }}
        } @else {
          {{ estimatedQuantityLabelKey | translate }}
        }
      </p>
    </div>
  }
</div>
